import { useI18n } from '../i18n';
import type { ActionKey } from '../api/types';
import { ACTION_GLYPH, actionLabelKey } from './ChoiceButtons';

/**
 * ★★ 「已出手，等待對手」畫面。
 *
 * 這個元件的 props **只有我自己的動作**。它在型別上就拿不到對手的任何東西，
 * 所以不可能不小心把對手的資訊畫出來 —— 這是刻意的設計約束，不是巧合。
 *
 * 我們也刻意**不**顯示「對手已出手 / 尚未出手」。後端的 `waiting_for` 會告訴我們，
 * 但把它畫出來，UI 就變成一條時序旁通道（你可以從「對方秒出」推測他在亂出）。
 * 兩位玩家看到的等待畫面完全一樣。
 */
export function WaitingForOpponent({ myAction }: { myAction: ActionKey | null }) {
  const { t } = useI18n();
  return (
    <section className="waiting" aria-live="polite">
      <div className="waiting__dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      <p className="h3">{t('match.waitingOpponent')}</p>
      {myAction ? (
        <p className="muted">
          {t('match.yourPick')}{' '}
          <strong>
            <span aria-hidden="true">{ACTION_GLYPH[myAction] ?? ''} </span>
            {t(actionLabelKey(myAction))}
          </strong>
        </p>
      ) : null}
      <p className="faint">{t('match.waitingOpponent.hint')}</p>
    </section>
  );
}
